import React from 'react';

/**
 * Loading skeleton component for TimeCardTable
 * Provides visual feedback while data is loading
 * Matches the new premium card-based design
 */
const TimeCardTableSkeleton = () => {
    return (
        <div className="space-y-6 animate-pulse">
            {/* Premium Summary Header Skeleton */}
            <div className="bg-gradient-to-r from-gray-300 to-gray-400 rounded-2xl shadow-xl p-6">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-white/30 rounded-full"></div>
                        <div>
                            <div className="h-5 bg-white/30 rounded w-32 mb-2"></div>
                            <div className="h-4 bg-white/30 rounded w-24"></div>
                        </div>
                    </div>
                    
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="bg-white/20 rounded-xl p-4 border border-white/30">
                                <div className="h-4 bg-white/30 rounded w-20 mb-2"></div>
                                <div className="h-8 bg-white/30 rounded w-16"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Date Cards Skeleton */}
            <div className="space-y-4">
                {[...Array(3)].map((_, dayIndex) => (
                    <div key={dayIndex} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                        {/* Date Header Skeleton */}
                        <div className="bg-gray-100 px-6 py-4 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-gray-300 rounded-xl"></div>
                                    <div>
                                        <div className="h-5 bg-gray-300 rounded w-32 mb-2"></div>
                                        <div className="h-4 bg-gray-300 rounded w-24"></div>
                                    </div>
                                </div>
                                <div className="space-y-2">
                                    <div className="h-4 bg-gray-300 rounded w-24 ml-auto"></div>
                                    <div className="h-4 bg-gray-300 rounded w-24 ml-auto"></div>
                                </div>
                            </div>
                        </div>

                        {/* Session Skeleton */}
                        <div className="p-6">
                            <div className="border-2 border-gray-200 rounded-xl p-5 bg-gray-50/30">
                                <div className="flex items-start justify-between mb-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-gray-300 rounded-lg"></div>
                                        <div>
                                            <div className="h-4 bg-gray-300 rounded w-20 mb-2"></div>
                                            <div className="h-3 bg-gray-300 rounded w-16"></div>
                                        </div>
                                    </div>
                                    <div className="h-8 bg-gray-300 rounded-lg w-20"></div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                    <div className="bg-white rounded-lg p-4 border border-gray-200">
                                        <div className="h-4 bg-gray-300 rounded w-20 mb-2"></div>
                                        <div className="h-6 bg-gray-300 rounded w-16"></div>
                                    </div>
                                    <div className="bg-white rounded-lg p-4 border border-gray-200">
                                        <div className="h-4 bg-gray-300 rounded w-20 mb-2"></div>
                                        <div className="h-6 bg-gray-300 rounded w-16"></div>
                                    </div>
                                </div>

                                <div className="bg-gray-200 rounded-lg p-4">
                                    <div className="h-4 bg-gray-300 rounded w-32 mb-2"></div>
                                    <div className="h-6 bg-gray-300 rounded w-20 ml-auto"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TimeCardTableSkeleton;
